import React from 'react';
import PropTypes from 'prop-types';

import Container from 'components/Container';

import { useIsMobileWithBreakpoint } from 'hooks/useIsMobileWithBreakpoint';

import Logo from '../Logo';
import Navigation from '../Navigation';

import styles from './styles.module.scss';

const Header = ({ anchors }) => {
	const isMobile = useIsMobileWithBreakpoint('mobileMedium');

	return (
		<header className={styles.Header}>
			<Container className={styles.Header__Container}>
				<Logo />
				{!isMobile ? <Navigation anchors={anchors} /> : null}
			</Container>
		</header>
	);
};

Header.propTypes = {
	anchors: PropTypes.arrayOf(
		PropTypes.shape({
			title: PropTypes.string,
			url: PropTypes.string
		})
	).isRequired
};

export default Header;
